import { useContext } from 'react';
import { MdArrowForward, MdMenu } from 'react-icons/md';
import { AppContext } from '../App';
import logoWorded from '../assets/logo_worded.png';

export default function TopBar() {
  const appContext = useContext(AppContext);
  const goTo = (item) => appContext.navTo({ item });
  const links = [['Home', 'home'], ['Products', 'services'], ['Clients', 'projects']];

  return (
    <header className="TopBar HospiumTopBar"><div className="body"><div className="container HospiumNav">
      <button className="HospiumMobileMenu mMobileOnly" onClick={appContext.openSideBar} aria-label="Open menu"><MdMenu /></button>
      <img className="HospiumNavLogo" src={logoWorded} alt="Hospium" onClick={() => goTo('home')} />
      <nav className="HospiumDesktopNav mDesktopOnly">
        {links.map(([label, item]) => <button key={item} data-active={appContext.navItem === item || (item === 'home' && !appContext.navItem)} onClick={() => goTo(item)}>{label}</button>)}
      </nav>
      <button className="btn btn-primary btn-rounded HospiumNavCta" onClick={() => goTo('contact_us')}>Place inquiry <MdArrowForward /></button>
    </div></div></header>
  );
}
